import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { NotificationsComponent } from 'app/modules/notification/components/notifications/notifications.component';
import { UserMenuComponent } from '../../../components/user-menu/user-menu.component';
import { NavbarService } from './navbar.service';

@Component({
    selector: 'app-navbar',
    standalone: true,
    imports: [
        CommonModule,
        MatIconModule,
        MatIconButton,
        NotificationsComponent,
        UserMenuComponent,
    ],
    templateUrl: './navbar.component.html',
    styleUrl: './navbar.component.scss',
})
export class NavbarComponent {
    private _navbarService = inject(NavbarService);

    matDrawerToggle(): void {
        this._navbarService.toggleDrawer();
    }
}
